var usaStockists = [
  {
    "lat": 41.9742611,
    "lng": -87.6680543,
    "name": "Foursided",
    "url": "http://www.foursided.com/",
    "address": "5061 North Clark Street, Chicago, IL, 60640, United States of America"
  },
  {
    "lat": 44.0590823,
    "lng": -121.3142881,
    "name": "ju-bee-lee and Jack+Millie",
    "url": "https://www.instagram.com/jubeeleebend/?hl=en",
    "address": "903 NW Wall ST, Bend, OR, 97703, United States of America"
  },
  {
    "lat": 35.2795775,
    "lng": -120.6636687,
    "name": "Len Collective",
    "url": "http://lencollective.com/",
    "address": "760 Higuera Street, San Luis Obispo, CA, 93401, United States of America"
  },
  {
    "lat": 32.74314013,
    "lng": -117.1277286,
    "name": "Pigment",
    "url": "https://www.shoppigment.com/",
    "address": "3855 Wabash Avenue, San Diego, CA, 92104, United States of America"
  },
  {
    "lat": 40.72097335,
    "lng": -73.99501765,
    "name": "ESQUELETO",
    "url": "http://shopesqueleto.com/",
    "address": "4618 Hollywood Boulevard, Los Angeles, CA, 90027, United States of America"
  },
  {
    "lat": 35.56470625,
    "lng": -121.08069325,
    "name": "Sea + green",
    "url": "http://www.sea-n-green.com/",
    "address": "2380 Main Street, Cambria, CA, 93428, United States of America"
  },
  {
    "lat": 35.56470625,
    "lng": -121.08069325,
    "name": "Sea + green",
    "url": "http://www.sea-n-green.com/",
    "address": "2380 Main Street, Cambria, CA, 93428, United States of America"
  },
  {
    "lat": 35.56470625,
    "lng": -121.08069325,
    "name": "Sea + green",
    "url": "http://www.sea-n-green.com/",
    "address": "2380 Main Street, Cambria, CA, 93428, United States of America"
  },
  {
    "lat": 35.56470625,
    "lng": -121.08069325,
    "name": "Sea + green",
    "url": "http://www.sea-n-green.com/",
    "address": "2380 Main Street, Cambria, CA, 93428, United States of America"
  },
  {
    "lat": 39.7328098,
    "lng": -104.9874073,
    "name": "La Lovely Vintage - Broadway St",
    "url": "http://lalovelyvintage.com/",
    "address": "42 N. Broadway, Denver , CO, 80203, United States of America"
  },
  {
    "lat": 27.27598982,
    "lng": -82.56436879,
    "name": "Casa Del Sol Boutique",
    "url": "https://casadelsol5.com/",
    "address": "5212 Ocean Boulevard, Siesta Key, FL, 34242, United States of America"
  },
  {
    "lat": 33.0385128,
    "lng": -117.2926446,
    "name": "GOODONYA® - Encinitas",
    "url": "https://www.goodonyaorganic.restaurant/",
    "address": "1051 South Coast Highway 101, Encinitas, CA, 92024, United States of America"
  },
  {
    "lat": 34.1631943534,
    "lng": -118.0515487,
    "name": "Little Mountain Salon",
    "url": "",
    "address": "43 East Montecito Avenue, Sierra Madre, CA, 91024, United States of America"
  },
  {
    "lat": 42.7308104,
    "lng": -84.4674534,
    "name": "Mad Eagle",
    "url": "http://www.madeagle.com/",
    "address": "317 E. Grand River Ave., East Lansing, MI, 48823, United States of America"
  },
  {
    "lat": 39.10684,
    "lng": -84.482465,
    "name": "Coda Co.",
    "url": "http://www.shopcodaco.com/",
    "address": "400 Fairfield Ave., Bellevue, KY, 41073, United States of America"
  },
  {
    "lat": 33.86273162,
    "lng": -118.4002405,
    "name": "FORMA",
    "url": "http://www.forma.la/",
    "address": "1227 Hermosa Avenue, Hermosa Beach, CA, 90254, United States of America"
  },
  {
    "lat": 38.2938773,
    "lng": -122.4583383,
    "name": "The Candlestick",
    "url": "http://www.thecandlestick.com/",
    "address": "38 West Spain Street, Sonoma, CA, 95476, United States of America"
  },
  {
    "lat": 32.747741,
    "lng": -117.134949,
    "name": "The Little Flower",
    "url": "",
    "address": "3804 Pershing Avenue, San Diego, CA, 92104, United States of America"
  },
  {
    "lat": 37.8027318,
    "lng": -122.2069026,
    "name": "Brother & Sisters Flower Shop",
    "url": "http://www.brotherandsistersflowers.com/contact/",
    "address": "4006 Laguna Avenue, Oakland, CA, 94602, United States of America"
  },
  {
    "lat": 35.1208068,
    "lng": -120.6045941,
    "name": "Tribe Coffeehouse",
    "url": "http://www.tribecoffeehouse.com/",
    "address": "1355 East Grand Avenue, Arroyo Grande, CA, 93420, United States of America"
  },
  {
    "lat": 37.8466772,
    "lng": -122.252143,
    "name": "The Yoni Temple",
    "url": "",
    "address": "5831 College Avenue, Oakland, CA, 94618, United States of America"
  },
  {
    "lat": 32.72875088,
    "lng": -117.1294897,
    "name": "Communal Coffee",
    "url": "",
    "address": "2209 Fern St. , San Diego , CA, 92104, United States of America"
  },
  {
    "lat": 21.2914727,
    "lng": -157.8437734,
    "name": "Sugar Sugar",
    "url": "https://sugarsugarhi.com/",
    "address": "1450 Ala Moana Boulevard, Honolulu, HI, 96814, United States of America"
  },
  {
    "lat": 32.749436,
    "lng": -117.246406,
    "name": "willow",
    "url": "",
    "address": "2102 Cable Street, San Diego, CA, 92107, United States of America"
  },
  {
    "lat": 34.14311955,
    "lng": -118.4012191,
    "name": "WildFlora",
    "url": "",
    "address": "12313 Ventura Boulevard, Los Angeles, CA, 91604, United States of America"
  },
  {
    "lat": 35.7903228,
    "lng": -78.6347895,
    "name": "Edge of Urge",
    "url": "http://edgeofurge.com/",
    "address": "215 e Franklin st, Raleigh, NC, 27604, United States of America"
  },
  {
    "lat": 42.5013208,
    "lng": -71.07664717,
    "name": "Boston Microneedling LLC",
    "url": "",
    "address": "21 Murray Street, Wakefield, MA, 01880, United States of America"
  },
  {
    "lat": 46.7803755,
    "lng": -92.0940618,
    "name": "Global Village",
    "url": "http://globalvillageduluth.com/",
    "address": "501 South Lake Avenue, Duluth, MN, 55802, United States of America"
  },
  {
    "lat": 32.7949753,
    "lng": -80.1075703,
    "name": "Sabal & Oak",
    "url": "",
    "address": "233 Hoggard Ln , Johns Island, SC, 29455, United States of America"
  },
  {
    "lat": 40.7499957,
    "lng": -111.885784,
    "name": "The Land of Salt",
    "url": "http://www.thelandofsalt.com/",
    "address": "177 E 900 S, Salt Lake City, UT, 84111, United States of America"
  },
  {
    "lat": 40.029425,
    "lng": -83.0154875,
    "name": "Tigertree",
    "url": "http://shoptigertree.com/",
    "address": "3301 North High Street, Columbus, OH, 43202, United States of America"
  },
  {
    "lat": 32.8481226,
    "lng": -117.27338,
    "name": "Thread + Seed - La Jolla",
    "url": "",
    "address": "7863 Girard Avenue, La Jolla, CA, 92037, United States of America"
  },
  {
    "lat": 32.842994,
    "lng": -117.273708,
    "name": "Trilogy Sanctuary",
    "url": "",
    "address": "7650 Girard Avenue, San Diego, CA, 92037, United States of America"
  },
  {
    "lat": 42.3895879,
    "lng": -71.1189212,
    "name": "Cambridge Naturals",
    "url": "http://www.cambridgenaturals.com/",
    "address": "23 White Street, Cambridge, MA, 02140, United States of America"
  },
  {
    "lat": 47.61246955,
    "lng": -122.2928863,
    "name": "Revival Shop Seattle",
    "url": "http://www.revivalshopseattle.com/",
    "address": "233 Broadway E, Seattle, WA, 98102, United States of America"
  },
  {
    "lat": 42.7322743673,
    "lng": -84.5523726531,
    "name": "Dear Ollie & Co.",
    "url": "",
    "address": "222 S. Washington Sq., Lansing, MI, 48933, United States of America"
  },
  {
    "lat": 41.6765836531,
    "lng": -83.6206371633,
    "name": "Yogaja Shop",
    "url": "",
    "address": "3146 Markway Road, Toledo, OH, 43606, United States of America"
  },
  {
    "lat": 29.6592922,
    "lng": -82.316444,
    "name": "The AUK Market",
    "url": "http://www.theaukmarket.com/",
    "address": "1021 NE 20th Ave, Gainesville, FL, 32609, United States of America"
  },
  {
    "lat": 32.765504,
    "lng": -117.018413,
    "name": "Small Batch",
    "url": "https://www.smallbatchcoffeeroasters.co.uk/",
    "address": "8332 La Mesa Blvd, La Mesa, CA, 91942, United States of America"
  },
  {
    "lat": 30.69417196,
    "lng": -88.04656853,
    "name": "Nova Espresso",
    "url": "https://www.horshamcoffeeroaster.co.uk/products/nova-espresso",
    "address": "306 Saint Anthony Street, Mobile, AL, 36603-6400, United States of America"
  },
  {
    "lat": 41.8452360571,
    "lng": -69.9779145714,
    "name": "ARTichoke",
    "url": "http://www.artichokecapecod.com/",
    "address": "4550 State HWY, Eastham, MA, 02642, United States of America"
  },
  {
    "lat": 43.5168194,
    "lng": -70.3767923,
    "name": "Café 64",
    "url": "",
    "address": "35 Old Orchard Street, Old Orchard Beach, ME, 04064, United States of America"
  },
  {
    "lat": 35.079012449,
    "lng": -106.5790961224,
    "name": "Mix",
    "url": "",
    "address": "208 Laguayra Dr NE, Albuquerque, NM, 87108, United States of America"
  },
  {
    "lat": 32.7495551,
    "lng": -97.3632991532,
    "name": "Modern Art Museum of Fort Worth",
    "url": "",
    "address": "3200 Darnell Street, Fort Worth, TX, 76107, United States of America"
  },
  {
    "lat": 42.2037166,
    "lng": -83.5429684,
    "name": "Eldorado General Store",
    "url": "http://www.eldoradogeneralstore.com/",
    "address": "51050 W Huron River Dr, Van Buren Twp, MI, 48111, United States of America"
  },
  {
    "lat": 34.0855692424,
    "lng": -118.2750072828,
    "name": "Le Pink",
    "url": "https://www.lepinkandco.com/",
    "address": "3208 W Sunset Boulevard, Los Angeles , CA, 90026, United States of America"
  },
  {
    "lat": 37.5525124,
    "lng": -77.47821718,
    "name": "Mongrel",
    "url": "http://www.mongrelrva.com/",
    "address": "2924 West Cary Street, Richmond, VA, 23221, United States of America"
  },
  {
    "lat": 41.9273359115,
    "lng": -73.9005527807,
    "name": "Winter Sun & Summer Moon",
    "url": "https://www.wintersunsummermoon.com/",
    "address": "10-14 East Market Street, Rhinebeck, NY, 12572, United States of America"
  },
  {
    "lat": 42.55065315,
    "lng": -70.88298531,
    "name": "Soy Much Brighter Candle Co.",
    "url": "http://www.soymuchbrighter.com/",
    "address": "285 Rantoul St, Beverly, MA, 01915, United States of America"
  },
  {
    "lat": 33.042086,
    "lng": -117.292865,
    "name": "Soulscape Gift & Book Store",
    "url": "",
    "address": "765 South Coast Highway 101, Encinitas, CA, 92024, United States of America"
  },
  {
    "lat": 32.7292485,
    "lng": -117.1300152,
    "name": "Gold Leaf",
    "url": "http://www.goldleafsouthpark.com/",
    "address": "2225 30th Street, San Diego, CA, 92104, United States of America"
  },
  {
    "lat": 44.6363834,
    "lng": -72.485195,
    "name": "Moss Boutique",
    "url": "https://www.instagram.com/mossboutiquemarseille/?hl=en",
    "address": "5831 Garfield Road, Hyde Park, VT, 05655, United States of America"
  },
  {
    "lat": 33.04483251,
    "lng": -117.2937866,
    "name": "Station salon",
    "url": "http://www.stationsalon.com/",
    "address": "594 S. Coast Hwy 101, Encinitas, CA, 92024, United States of America"
  },
  {
    "lat": 44.7558801,
    "lng": -85.6429309,
    "name": "Sanctuary Goods",
    "url": "http://www.sanctuarygoods.com/",
    "address": "800 Cottageview Drive, Traverse City, MI, 49684, United States of America"
  },
  {
    "lat": 42.63960974,
    "lng": -85.30670321,
    "name": "Kindred Shop & Studio LLC",
    "url": "http://www.shopkindred.ca/",
    "address": "1035 David Dr., Hastings, MI, 49058, United States of America"
  },
  {
    "lat": 32.720595,
    "lng": -117.230798,
    "name": "Rare Bloom Boutique",
    "url": "https://rarebloomboutique.com/",
    "address": "2841 Cañon Street, San Diego, CA, 92106, United States of America"
  },
  {
    "lat": 44.86541991,
    "lng": -87.38150564,
    "name": "Blue Ivy",
    "url": "http://blueivyboutique.com/",
    "address": "4025 Bay Shore Drive, Sturgeon Bay, WI, 54235, United States of America"
  },
  {
    "lat": 40.07591602,
    "lng": -75.47527611,
    "name": "Thistle Be Perfect",
    "url": "http://www.thistlebeperfectshop.com/",
    "address": "1748 Burgoyne Road, Chesterbrook, PA, 19087, United States of America"
  },
  {
    "lat": 40.7520450035,
    "lng": -111.8827572276,
    "name": "Mineral and Matter",
    "url": "",
    "address": "177 E 900 S STE C, Salt lake City, UT, 84111, United States of America"
  },
  {
    "lat": 33.133116,
    "lng": -117.229573,
    "name": "LEAF - Live Enlightened And Free",
    "url": "http://liveenlightenedandfree.com/",
    "address": "3225 Business Park Drive, Vista, CA, 92081, United States of America"
  },
  {
    "lat": 40.7452413,
    "lng": -74.0436435,
    "name": "Lucky Honey Bee",
    "url": "http://www.theluckyhoneybee.com/",
    "address": "487 Palisade Avenue, Jersey City, NJ, 07307, United States of America"
  },
  {
    "lat": 41.9029748,
    "lng": -87.6753584,
    "name": "Gemini",
    "url": "http://geminishop.com/",
    "address": "1911 W Division St, Chicago, IL, 60622, United States of America"
  },
  {
    "lat": 43.31027675,
    "lng": -73.6447820935,
    "name": "Minky Mink",
    "url": "",
    "address": "203 Glen Street, Glens Falls, NY, 12801, United States of America"
  },
  {
    "lat": 34.14860325,
    "lng": -118.2812686438,
    "name": "Autry Museum of the American West",
    "url": "",
    "address": "4700 Western Heritage Way, Los Angeles, CA, 90027, United States of America"
  },
  {
    "lat": 37.8437858,
    "lng": -122.2515901,
    "name": "Nathan & Co",
    "url": "https://nathanandco.com/",
    "address": "5636 college ave , Oakland, CA, 94618, United States of America"
  },
  {
    "lat": 28.1203232,
    "lng": -80.7168068,
    "name": "The Standard Collective",
    "url": "https://maps.google.com/?cid=3388898668226399129",
    "address": "559 West Eau Gallie Boulevard, Melbourne, FL, 32935, United States of America"
  },
  {
    "lat": 33.80984259,
    "lng": -116.5051624,
    "name": "Covet Boutique",
    "url": "https://www.covetsf.com/",
    "address": "833 Arroyo Vista Dr., Palm Springs, CA, 92264, United States of America"
  },
  {
    "lat": 39.43424624,
    "lng": -84.20855283,
    "name": "Blume Home",
    "url": "https://www.instagram.com/blumeshop.home/?hl=en",
    "address": "9 S. Broadway, Lebanon, OH, 45036, United States of America"
  },
  {
    "lat": 38.447686,
    "lng": -78.8696684,
    "name": "Lineage",
    "url": "http://lineagegoods.com/",
    "address": "3106 West Cary Street, Richmond, VA, 23221, United States of America"
  },
  {
    "lat": 40.3657914,
    "lng": -74.1680874,
    "name": "Enchanted Blossoms NJ",
    "url": "",
    "address": "101 Crawfords Corner Road, Holmdel, NJ, 07733, United States of America"
  },
  {
    "lat": 37.9941898432,
    "lng": -122.1339737886,
    "name": "House of Petals",
    "url": "",
    "address": "4030 Raap Ave, Martinez, CA, 94553, United States of America"
  },
  {
    "lat": 33.9822723701,
    "lng": -118.45144715,
    "name": "Hallowed Ground",
    "url": "",
    "address": "114 Washington Boulevard Suite B, Marina Dey Rey, CA, 90292, United States of America"
  },
  {
    "lat": 32.2266567563,
    "lng": -110.9656665731,
    "name": "Antigone Books",
    "url": "https://www.antigonebooks.com/",
    "address": "411 North 4th Avenue, Tucson, AZ, 85705, United States of America"
  },
  {
    "lat": 48.9985019,
    "lng": -116.5007211,
    "name": "Modern Alchemy",
    "url": "",
    "address": "108 Trading Post Road, Bonners Ferry, ID, 83805, United States of America"
  },
  {
    "lat": 36.0815342,
    "lng": -94.20563106,
    "name": "The Boho Boutique",
    "url": "https://shopthebohoboutique.com/",
    "address": "3231 W Montrail Pl, Fayetteville, AR, 72704, United States of America"
  },
  {
    "lat": 40.8478647715,
    "lng": -124.0674867138,
    "name": "Forever Florals",
    "url": "",
    "address": "1560 Old Arcata Rd, Arcata, CA, 95521, United States of America"
  },
  {
    "lat": 40.56782705,
    "lng": -105.0404205386,
    "name": "Bath Garden Center and Nursery",
    "url": "",
    "address": "2000 East Prospect Road, Fort Collins, CO, 80525, United States of America"
  },
  {
    "lat": 39.33114115,
    "lng": -76.6291366,
    "name": "In Watermelon Sugar",
    "url": "http://www.inwatermelonsugarshop.com/",
    "address": "3555 Chestnut Avenue, Baltimore, MD, 21211, United States of America"
  },
  {
    "lat": 37.98674641,
    "lng": -122.5889448,
    "name": "The Herban Garden",
    "url": "http://www.theherbangarden.net/",
    "address": "15 Bolinas Road, Fairfax, CA, 94930, United States of America"
  },
  {
    "lat": 41.0067156,
    "lng": -73.8722884,
    "name": "Fourteen August, LLC",
    "url": "",
    "address": "197 Clinton Avenue, Dobbs Ferry, NY, 10522, United States of America"
  },
  {
    "lat": 47.56799255,
    "lng": -122.4009969678,
    "name": "Artist and Muse salon",
    "url": "",
    "address": "4017 53rd Ave SW, Seattle, WA, 98116, United States of America"
  },
  {
    "lat": 35.7819408,
    "lng": -78.7800905,
    "name": "Gather Goods Co",
    "url": "",
    "address": "417 Kildaire Farm Road, Cary, NC, 27511, United States of America"
  },
  {
    "lat": 41.5080935,
    "lng": -73.9751079,
    "name": "Witch Hazel",
    "url": "",
    "address": "176 Main Street, Beacon, NY, 12508, United States of America"
  },
  {
    "lat": 41.59002368,
    "lng": -93.61312821,
    "name": "KIN",
    "url": "https://www.kindsm.com/",
    "address": "333 E Grand Ave #106, Des Moines, IA, 50309, United States of America"
  },
  {
    "lat": 34.414992,
    "lng": -119.694152,
    "name": "Folio Press & Paperie",
    "url": "",
    "address": "301 Motor Way, Santa Barbara, CA, 93101, United States of America"
  },
  {
    "lat": 42.3825656,
    "lng": -71.1803292,
    "name": "Hip Finds Co. LLC",
    "url": "",
    "address": "25 EMERSON RD, DURHAM, NH, 03824-2104, United States of America"
  },
  {
    "lat": 35.2216179184,
    "lng": -97.4414251837,
    "name": "Human Interaction",
    "url": "http://www.thehumaninteraction.com/",
    "address": "224 e main street, norman, OK, 73069, United States of America"
  },
  {
    "lat": 38.57406399,
    "lng": -109.5506663,
    "name": "Desert Sol",
    "url": "http://www.desertsol.com/",
    "address": "50 N Main Street, Moab, UT, 84532, United States of America"
  },
  {
    "lat": 34.13703794,
    "lng": -118.4009446,
    "name": "Greenwood Shop",
    "url": "https://www.greenwoodsoflondon.co.uk/shopping",
    "address": "12063 Ventura Place, Studio City, CA, 91604, United States of America"
  },
  {
    "lat": 34.10302252,
    "lng": -118.29167496,
    "name": "BellJar",
    "url": "http://shop-belljar.com/",
    "address": "1764 North Vermont Avenue, Los Angeles, CA, 90027, United States of America"
  },
  {
    "lat": 45.68881475,
    "lng": -122.5923951091,
    "name": "SomaDoma, LLC",
    "url": "",
    "address": "9208 Northeast 79th Court, Vancouver, WA, 98662, United States of America"
  },
  {
    "lat": 37.974072,
    "lng": -122.536304,
    "name": "Bourrée Boutique",
    "url": "",
    "address": "100 F Street, San Rafael, CA, 94901, United States of America"
  },
  {
    "lat": 37.13748771,
    "lng": -85.95782774,
    "name": "The Dive",
    "url": "",
    "address": "203 Broadway St, Cave City, KY, 42127, United States of America"
  },
  {
    "lat": 44.8095107,
    "lng": -91.50354883,
    "name": "Token Jewelry",
    "url": "https://tokenjewelry.com/",
    "address": "106 W. Grand Ave, Eau Claire, WI, 54703, United States of America"
  },
  {
    "lat": 37.79344541,
    "lng": -122.4211613,
    "name": "Picnic",
    "url": "http://www.picnicsf.com/",
    "address": "1808 Polk Street, San Francisco, CA, 94109, United States of America"
  },
  {
    "lat": 45.504705,
    "lng": -122.6278378,
    "name": "Gone West PDX",
    "url": "https://www.gonewestpdx.com/",
    "address": "3542 SE DIVISION STREET, Portland, OR, 97202, United States of America"
  },
  {
    "lat": 42.956695,
    "lng": -85.6341689,
    "name": "Spirit Dreams",
    "url": "https://www.spiritdreamsgr.com/",
    "address": "1430 Lake Drive SE, Grand Rapids, MI, 49506, United States of America"
  },
  {
    "lat": 34.45134946,
    "lng": -119.2384042,
    "name": "Sunday Designs",
    "url": "https://www.sundaydesigns.co/",
    "address": "405 North Fulton, Ojai, CA, 93023, United States of America"
  },
  {
    "lat": 33.16015451,
    "lng": -117.3478623,
    "name": "Rebel Villa",
    "url": "https://www.rebelvilla.com/",
    "address": "592 Carlsbad Village Drive, Carlsbad, CA, 92008, United States of America"
  },
  {
    "lat": 44.0459668,
    "lng": -121.3158562,
    "name": "Vanilla Urban Threads",
    "url": "https://www.shopvanilla.com/",
    "address": "425 Southwest Powerhouse Drive, Bend, OR, 97702, United States of America"
  },
  {
    "lat": 36.6010750408,
    "lng": -121.8939865612,
    "name": "The Feral Market",
    "url": "https://www.facebook.com/theferalmarket",
    "address": "261 Alvarado Street, Monterey, CA, 93940, United States of America"
  },
  {
    "lat": 40.0756812318,
    "lng": -74.0842471503,
    "name": "Sun Baked Surf Boutique",
    "url": "",
    "address": "3112 Bridge Avenue, Point Pleasant, NJ, 08742, United States of America"
  },
  {
    "lat": 34.0904617,
    "lng": -118.3836827,
    "name": "Catherine Keaveney",
    "url": "",
    "address": "8818 West Sunset Boulevard, West Hollywood, CA, 90069, United States of America"
  },
  {
    "lat": 37.2705053667,
    "lng": -121.9612598582,
    "name": "Spellcraft",
    "url": "",
    "address": "1120 Capri Drive, Campbell, CA, 95008, United States of America"
  },
  {
    "lat": 44.47392519,
    "lng": -73.21093942,
    "name": "KYLEE BOUTIQUE",
    "url": "",
    "address": "198 College Street , Burlington, VT, 05401, United States of America"
  },
  {
    "lat": 30.173604,
    "lng": -97.8129199347,
    "name": "Yarrow & Sage",
    "url": "",
    "address": "1201 West Slaughter Lane, Austin, TX, 78748, United States of America"
  },
  {
    "lat": 34.0491458182,
    "lng": -118.2413306364,
    "name": "Gavi deNavi",
    "url": "",
    "address": "321 East 2nd Street, Los Angeles, CA, 90012, United States of America"
  },
  {
    "lat": 40.0931323878,
    "lng": -74.0498211429,
    "name": "Saltwater Culture",
    "url": "",
    "address": "420 Richmond Avenue, Point Pleasant Beach, NJ, 08742, United States of America"
  },
  {
    "lat": 42.2809173,
    "lng": -83.74891872,
    "name": "Crazy Wisdom",
    "url": "https://shopcrazywisdom.indielite.org/welcome",
    "address": "114 S. Main Street, Ann Arbor, MI, 48104, United States of America"
  },
  {
    "lat": 40.63915918,
    "lng": -73.96842061,
    "name": "Brooklyn ARTery",
    "url": "http://www.brooklynartery.com/",
    "address": "1004 Cortelyou Road, Brooklyn, NY, 11218-5302, United States of America"
  },
  {
    "lat": 40.713712861,
    "lng": -74.174022511,
    "name": "1609 Design c/o BWS-BOSS",
    "url": "",
    "address": "825 Frelinghuysen Avenue, Newark, '07114, United States of America"
  },
  {
    "lat": 18.40691,
    "lng": -67.172077,
    "name": "Summer Love",
    "url": "",
    "address": "1404 Bo Espinar, Aguada, '00602, United States of America"
  },
  {
    "lat": 34.8994541544,
    "lng": -111.3247476386,
    "name": "Tao Fellowship",
    "url": "",
    "address": "989 S. Main Street Suite A, Cottonwood, 86326, United States of America"
  }
]